// FR-003: convert a flat v_tariff_pairs row into two TariffDom objects
// (advance + optional late). LATE-twin lifecycle fields (idServiceZone, type,
// validFrom, validTo, isActive) mirror the advance row; only price columns
// and isLateTwin=true differ on the twin.
export const TariffPairMapper = {
    rowToDomain(row) {
        const advance = {
            id: row.id_advance,
            idServiceZone: row.id_service_zone,
            name: row.name,
            type: row.type,
            pricePerKwh: row.advance_price_per_kwh ?? null,
            oneTimeServiceFee: row.advance_one_time_fee,
            emergencyServiceFee: row.advance_emergency_fee ?? null,
            subscriptionPrice: row.subscription_price ?? null,
            subscriptionDurationDays: row.subscription_duration_days ?? null,
            subscriptionKwhLimit: row.subscription_kwh_limit ?? null,
            subscriptionVisitLimit: row.subscription_visit_limit ?? null,
            rolloverType: row.rollover_type ?? null,
            overLimitPricePerKwh: row.over_limit_price_per_kwh ?? null,
            overLimitVisitPrice: row.over_limit_visit_price ?? null,
            isDefault: row.is_default,
            isLateTwin: false,
            idLateTariff: row.id_late_tariff ?? null,
            cutoffHourMsk: row.cutoff_hour_msk ?? null,
            cutoffOffsetDays: row.cutoff_offset_days ?? null,
            validFrom: row.valid_from,
            validTo: row.valid_to ?? null,
            isActive: row.is_active,
            createdAt: row.created_at ?? null,
            updatedAt: row.updated_at ?? null,
            isDeleted: row.is_deleted ?? false,
            idCreatedBy: null,
            idUpdatedBy: null,
        };
        const late = row.id_late_tariff
            ? {
                id: row.id_late_tariff,
                idServiceZone: row.id_service_zone,
                name: `${row.name} (LATE)`,
                type: row.type,
                pricePerKwh: row.late_price_per_kwh ?? null,
                oneTimeServiceFee: row.late_one_time_fee ?? 0,
                emergencyServiceFee: row.late_emergency_fee ?? null,
                subscriptionPrice: null,
                subscriptionDurationDays: null,
                subscriptionKwhLimit: null,
                subscriptionVisitLimit: null,
                rolloverType: null,
                overLimitPricePerKwh: null,
                overLimitVisitPrice: null,
                isDefault: false,
                isLateTwin: true,
                idLateTariff: null,
                cutoffHourMsk: null,
                cutoffOffsetDays: null,
                validFrom: row.valid_from,
                validTo: row.valid_to ?? null,
                isActive: row.is_active,
                createdAt: row.created_at ?? null,
                updatedAt: row.updated_at ?? null,
                isDeleted: row.is_deleted ?? false,
                idCreatedBy: null,
                idUpdatedBy: null,
            }
            : null;
        return { advance, late };
    },
};
